import Tom_Ford from "../assets/images/Tom Ford Black Orchid.jpg";
import Hugo_Scent from "../assets/images/Hugo Boss The Scent.jpg";
import Daisy from "../assets/images/Marc Jacobs Daisy.jpg";
import Chanel_5 from "../assets/images/Chanel N°5.jpg";
import Prada_Candy from "../assets/images/Prada Candy.jpg";
import YSL from "../assets/images/Yves Saint Laurent Libre.jpg";
import Versace from "../assets/images/Versace Bright Crystal.jpg";
import Gioia from "../assets/images/Giorgio Armani Acqua di Gioia.jpg";
import Gio from "../assets/images/Giorgio Armani Acqua di Giò.jpg";
import Dior from "../assets/images/Dior J_adore.jpg";
import D_G from "../assets/images/Dolce and Gabbana Light Blue.jpg";
import Bloom from "../assets/images/Gucci Bloom.jpg";

const perfumes = [
  { id: "1", name: "Tom Ford Black Orchid", price: 24.99, image: Tom_Ford },
  { id: "2", name: "Hugo Boss The Scent", price: 19.99, image: Hugo_Scent },
  { id: "3", name: "Marc Jacobs Daisy", price: 20.79, image: Daisy },
  { id: "4", name: "Yves Saint Laurent Libre", price: 150.99, image: YSL },
  { id: "5", name: "Chanel N°5", price: 34.99, image: Chanel_5 },
  { id: "6", name: "Prada Candy", price: 21.99, image: Prada_Candy },
  { id: "7", name: "Versace Bright Crystal", price: 41.99, image: Versace },
  { id: "8", name: "Giorgio Armani Acqua di Gioia", price: 21.99, image: Gioia,},
  { id: "9", name: "Dior J'adore", price: 21.99, image: Dior },
  { id: "10", name: "Dolce and Gabbana Light Blue", price: 21.99, image: D_G },
  { id: "11", name: "Gucci Bloom", price: 21.99, image: Bloom },
  { id: "12", name: "Giorgio Armani Acqua di Giò", price: 55.99, image: Gio },
];

export default perfumes